import * as actions from "./types/cartActionType";

export const goToCheckout = () => ({
	type: actions.GO_TO_CHECKOUT
});
